import { Routes, Route } from 'react-router-dom'
import {
  createTheme,
  CssBaseline,
  ThemeProvider,
  // useMediaQuery
} from '@mui/material'
import { RoutesProvider } from './store/routesContext'
import { DataMergingAndValidation } from './pages/DataMerginAndValidation'
import { MergeContext } from './store/mergeContext'
import Login from './pages/Login'
import Home from './pages/Home'
import Signup from './pages/Signup'
import User from './pages/User'
import Admin from './pages/Admin'
import Statistics from './pages/Statistics'
import History from './pages/History'
import Help from './pages/Help'
import { cloneElement, createContext, useMemo, useState } from 'react'
import ForgotPwd from './pages/ForgotPwd'
import { ActionLogsProvider } from './store/actionLogsContext'
import ReportAccidentNew from './pages/ReportAccidentNew'

export const ThemeContext = createContext()

export default function App () {
  const user = JSON.parse(localStorage.getItem('adams_user'))
  const [mode, setMode] = useState(user ? user.theme :  'light')
  const theme = useMemo(
    () =>
      createTheme({
        palette: {
          mode
          , primary: {
            main: mode === 'light' ? '#10171f' : '#f6d552'
          }
          , background: {
            default : mode === 'light' ? '#fff' : '#10171f'
            , paper   : mode === 'light' ? '#fff' : '#10171f'
          },
          newColors: {
            cyan: '#28BDE0',
            yellow: '#E0D028',
            pink: '#E0286C',
            bordeaux: '#8B4860',
            gray: '#425B61' ,
            lightGray:  '#EDEDED',
            black: '#3C3C3B',
            pinkGradient: 'linear-gradient(90deg, #941B47, #E0296B)',
            cyanGradient: 'linear-gradient(90deg, #007B98, #28BBDF)',
          }
        }
        , typography: {
          root: {
            color: '#ccc'
          }
          , h3: {
            fontSize       : '1.5rem'
            , fontWeight   : 'bold'
          }
          , h5: {
            fontSize: '1.2rem'
          }
          , h4: {
            fontSize: '1.4rem'
          }
        }
        , mixins: {
          drawerWidth     : 256
          , formDrawerWidth : 320
          , toolbar         : {
            minHeight: 64
          }
        }
        , components: {
          MuiCardHeader: {
            styleOverrides: {
              root: {
                padding: '0 0 0 10px'
              }
            }
          }
          , MuiPaper: {
            styleOverrides: {
              gap: '12px'
            }
          }
          , MuiDataGrid: {
            styleOverrides: {
              root: {
                color             : 'black'
                , backgroundColor : '#ccc'
              }
              , columnHeaderTitle: {
                fontWeight      : 'bold'
                , textTransform : 'capitalize'
              }
              , toolbarContainer: {
                backgroundColor: '#aaa'
              }
            }
          }
          , MuiCollapse: {
            styleOverrides: {
              root: ({ theme }) => ({
                marginRight       : '0px'
                , marginLeft      : '10px'
                , boxShadow       : theme.palette.mode === 'dark' ? '-2px 0px 1px #f6d552' : '-2px 0px 1px rgba(0, 0, 0, 0.6)'
                , borderRadius    : '2px'
              })
            }
          }
        }
      }),
    [mode]
  )

  // const isMobileAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

  // if (isMobileAgent) {
  // // Add mobile-specific logic here
  // } else {
  // // Add desktop-specific logic here
  // }

  // const isChrome = /Chrome/i.test(navigator.userAgent)
  // const isSafari = /Safari/i.test(navigator.userAgent) && !/Chrome/i.test(navigator.userAgent)
  // const isFirefox = /Firefox/i.test(navigator.userAgent)

  // const platform = navigator.platform

  // const isSmallScreen = window.matchMedia('(max-width: 600px)').matches

  const isTouch = navigator.maxTouchPoints > 0

  const isStandalone = window.matchMedia('(display-mode: standalone)').matches
  const isMobile = isStandalone || isTouch
  // const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const toggleTheme = m => {
    if(m){
      setMode(m)
    } else {
      mode === 'dark' ? setMode('light') : setMode('dark')
    }
  }

  const routes = [
    { path: '/home', element: <Home themeMode={mode} setThemeMode={setMode} /> }
    , { path: '/statistics', element: <Statistics /> }
    , { path: '/admin', element: <Admin /> }
    , {
      path      : '/tools'
      , element : (
        <MergeContext>
          <DataMergingAndValidation />
        </MergeContext>
      )
    }
    , { path: '/history', element: <History /> }
    , { path: '/help', element: <Help /> }
  ]

  const [handledCrash, setHandledCrash] = useState({})
  const handleRowClick = ({ row }) => setHandledCrash({
    id             : row['Crash id']
    , organization : row.organization
    , reporterId   : row.merge_date ? undefined : row.user_id
  })

  return (
    <ThemeContext.Provider value={{ mode, toggleTheme }}>
      <ThemeProvider theme={theme}>

        <CssBaseline />
        <ActionLogsProvider>
          <RoutesProvider routes={routes.map(route => route.path)}>
            <Routes>
              <Route path='/' element={<Login setThemeMode={setMode} isMobile={isMobile} />} />
              <Route path='/signup' element={<Signup isMobile={isMobile} />} />
              <Route path='/forgot-pwd' element={<ForgotPwd isMobile={isMobile} />} />
              <Route path='report-accident' element={<ReportAccidentNew isMobile={isMobile}/>}></Route>
              <Route path='/user' element={<User isMobile={isMobile} />} />
              {routes.map(({ path, element }, position) =>
                <Route
                  key={path}
                  path={path}
                  element={cloneElement(element, { position, isMobile, handleRowClick, handledCrash })}
                />)}
            </Routes>
          </RoutesProvider>
        </ActionLogsProvider>
      </ThemeProvider>
    </ThemeContext.Provider>
  )
}

// const defaultTheme = createTheme({})
// , components: {
//   MuiCssBaseline: {
//     styleOverrides: themeParams => ({
//       body: {
//         scrollbarColor                                   : '#ebebeb #2b2b2b'
//         , '&::-webkit-scrollbar, & *::-webkit-scrollbar' : {
//           backgroundColor: '#ebebeb'
//         }
//         , '&::-webkit-scrollbar-track, & *::-webkit-scrollbar-track': {
//           width           : '8px'
//           , backgroundColor : orange[500]// '#6b6b6b'
//         }
//         , '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
//           borderRadius      : 8
//           , backgroundColor : orange[500]// '#6b6b6b'
//           , minHeight       : 24
//           , border          : '0px solid #2b2b2b'
//         }
//         , '&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus': {
//           backgroundColor: '#959595'
//         }
//         , '&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active': {
//           backgroundColor: '#959595'
//         }
//         , '&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover': {
//           backgroundColor: '#959595'
//         }
//         , '&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner': {
//           backgroundColor: '#ff0000'
//         }
//       }
//     })
//   }
// }

// {
//   '& .scroll-bar::-webkit-scrollbar-track'   : { width: '8px' }
//   , '& .scroll-bar::-webkit-scrollbar-track' : { background: '#d5d2d2' }
//   , '& .scroll-bar::-webkit-scrollbar-thumb' : { backgroundColor: '#7e7c7e',  borderRadius: '4px', border: '0px solid #7e7c7e' }
//   ,'& .scroll-bar::-webkit-scrollbar-thumb:hover': { backgroundColor: '#494849' }
// }
